import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Login from '../../views/Login'
import { loginAction } from '../../store/auth/action';

export class LoginContainer extends Component {
  render() {
    const { login, token } = this.props
    if (token) {
      return <Redirect to="/" />;
    }
    return (
      <Login 
        { ...this.props }
        onLogin={ login } 
      />
    )
  }
}

const mapStateToProps = ({ auth }) => {
  return {
    token: auth.token,
    error: auth.error,
    loading: auth.loading
  }
}

const mapDispatchToProps = dispatch => ({
  login: (data) => dispatch(loginAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer)



// WEBPACK FOOTER //
// ./src/containers/Auth/Login.js